import { BarChart3 } from "lucide-react";

export default function Analytics() {
  return (
    <div className="p-6" data-testid="analytics-page">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <BarChart3 className="w-6 h-6 text-indigo-600" />
          Analytics
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          Deeper insights across your book — placeholder page. Tell the team what you want here.
        </p>
      </div>

      <div
        className="rounded-lg border border-dashed border-gray-300 bg-white p-10 text-center"
        data-testid="analytics-placeholder"
      >
        <BarChart3 className="w-10 h-10 text-gray-300 mx-auto mb-3" />
        <div className="text-sm text-gray-500">
          No analytics widgets yet. Widgets like AMC concentration, cohort XIRR,
          SIP momentum, TER-drag heatmap or client-vintage tables can plug in
          here.
        </div>
      </div>
    </div>
  );
}
